import Vue from 'vue';
import * as moment from 'moment';

export default Vue.filter('date', (value, format = 'DD/MM/YYYY') => {
  return moment(value).format(format);
});
